module.exports = __webpack_public_path__ + "img/logo_mb.cbe3cc4a.png";